// extracted by mini-css-extract-plugin
export default {"google_option":"SearchAutocomplete_google_option__YIWib"};